import { formatBRL } from "@immi/ui/lib/money"

import type { Lesson } from "@/types/database"

// Copy fixa da plataforma — não é campo do curso (mesmos valores hardcoded
// no checkout hoje).
export const SALES_FIXED = {
  accessMonths: 6,
  guaranteeDays: 7,
} as const

export const CEFR_LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"] as const

export const COURSE_TYPE_LABEL: Record<string, string> = {
  language: "Curso de idioma",
  exam_prep: "Preparatório",
  professional: "Curso profissional",
}

export { formatBRL }

export function formatBRL0(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  }).format(value)
}

export function formatNum(value: number): string {
  return new Intl.NumberFormat("pt-BR").format(value)
}

/** sum(duration_seconds) → "62h" (ou "45min" abaixo de 1h). */
export function formatHours(seconds: number): string {
  const h = Math.round(seconds / 3600)
  return h >= 1 ? `${h}h` : `${Math.round(seconds / 60)}min`
}

/** "18 de agosto" — timezone fixa para não derivar do relógio do servidor. */
export function formatDatePt(iso: string): string {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "numeric",
    month: "long",
    timeZone: "America/Sao_Paulo",
  }).format(new Date(iso))
}

export function discountPct(price: number, discountPrice: number): number {
  if (!(price > 0) || !(discountPrice > 0) || discountPrice >= price) return 0
  return Math.round((1 - discountPrice / price) * 100)
}

export type HeroStat = { value: string; label: string }

const TWELVE_HOURS_SECONDS = 43200

/**
 * Stats do hero: só o que dá para contar. Curso curto (<12h) não exibe
 * horas — a duração média por aula vende melhor. 4º stat: simulados,
 * senão alunos, senão só 3 stats.
 */
export function heroStats(
  totals: { sections: number; lessons: number; durationSeconds: number },
  mockExamsCount: number,
  enrollmentCount: number | null
): HeroStat[] {
  const stats: HeroStat[] = [
    { value: formatNum(totals.sections), label: "módulos" },
    { value: formatNum(totals.lessons), label: "aulas" },
  ]
  if (totals.durationSeconds >= TWELVE_HOURS_SECONDS) {
    stats.push({
      value: formatHours(totals.durationSeconds),
      label: "de conteúdo",
    })
  } else if (totals.lessons > 0) {
    stats.push({
      value: `${Math.round(totals.durationSeconds / totals.lessons / 60)} min`,
      label: "por aula, em média",
    })
  }
  if (mockExamsCount > 0) {
    stats.push({ value: formatNum(mockExamsCount), label: "simulados" })
  } else if (enrollmentCount) {
    stats.push({ value: `${formatNum(enrollmentCount)}+`, label: "alunos" })
  }
  return stats
}

const LESSON_KIND_LABEL: Record<string, string> = {
  video: "vídeo",
  text: "texto",
  pdf: "PDF",
}

/** Meta da linha de aula: duração quando houver, senão o tipo. */
export function lessonMeta(
  lesson: Pick<Lesson, "duration_seconds" | "type">
): string {
  if (lesson.duration_seconds > 0) {
    return `${Math.round(lesson.duration_seconds / 60)} min`
  }
  return LESSON_KIND_LABEL[lesson.type ?? ""] ?? "—"
}
